import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getLeads, createLead, extractFromImage, getStakeholderTypes } from '../api/api';
import type { Lead, CreateLeadInput } from '../types';

export const leadKeys = {
  all: ['leads'] as const,
  list: () => [...leadKeys.all, 'list'] as const,
  stakeholderTypes: () => [...leadKeys.all, 'stakeholder-types'] as const,
};

export function useStakeholderTypes() {
  return useQuery({
    queryKey: leadKeys.stakeholderTypes(),
    queryFn: getStakeholderTypes,
  });
}

export function useLeads() {
  return useQuery({
    queryKey: leadKeys.list(),
    queryFn: getLeads,
  });
}

export function useCreateLead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateLeadInput) => createLead(input),
    onSuccess: (data: Lead) => {
      queryClient.invalidateQueries({ queryKey: leadKeys.list() });
      queryClient.setQueryData(leadKeys.list(), (old: Lead[] | undefined) =>
        old ? [data, ...old] : [data]
      );
    },
  });
}

export function useExtractFromImage() {
  return useMutation({
    mutationFn: (imageFile: File) => extractFromImage(imageFile),
  });
}
